@switch (context ? context.type : '') {
    @default {
        <fui-edit-localisation-input #input (focussed$)="onFocussed($event)"></fui-edit-localisation-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-localisation-input #input [label]="label" [localised]="localised" [(ngModel)]="value"
                                       (focussed$)="onFocussed($event)"
        ></fui-filter-localisation-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-localisation-input #input (focussed$)="onFocussed($event)"
        ></fui-inline-localisation-input>
    }
    @case (contextType.PILL) {
        <fui-localisation-pill (focussed$)="onFocussed($event)"></fui-localisation-pill>
    }
    @case (contextType.POP) {
        <fui-pop-localisation-input #input (focussed$)="onFocussed($event)"
        ></fui-pop-localisation-input>
    }
}
